(() => {
  const reveal = (image) => {
    const container = image.parentElement;
    if (container?.hasAttribute('data-native-image') && image.complete && image.naturalWidth > 0) {
      container.classList.add('image-loaded');
    }
  };
  const scan = (root) => {
    if (root instanceof HTMLImageElement) reveal(root);
    root.querySelectorAll?.('[data-native-image] > img').forEach(reveal);
  };
  document.addEventListener('load', (event) => {
    if (event.target instanceof HTMLImageElement) reveal(event.target);
  }, true);
  scan(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      }
    }
  }).observe(document.body, {childList: true, subtree: true});
})();
